import React from 'react'
import { Link } from 'react-router-dom'

export type Crumb = { label: string; to?: string }

type Props = {
  breadcrumbs?: Crumb[]
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
}

const PageHeader: React.FC<Props> = ({
  breadcrumbs,
  title,
  subtitle,
  actions
}) => (
  <header className="dx-header">
    {breadcrumbs && breadcrumbs.length > 0 && (
      <nav className="dx-crumbs" aria-label="Breadcrumb">
        <ol>
          {breadcrumbs.map((crumb) => (
            <li key={`${crumb.label}-${crumb.to ?? 'current'}`}>
              {crumb.to ? (
                <Link to={crumb.to}>{crumb.label}</Link>
              ) : (
                <span aria-current="page">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    )}
    <div className="dx-header__row">
      <div className="dx-header__text">
        <h1 className="dx-header__title">{title}</h1>
        {subtitle && <p className="dx-header__subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="dx-header__actions">{actions}</div>}
    </div>
  </header>
)

export default PageHeader
